import { SimpleFlex } from '@eversports/react-components/primitives/Flex'
import { SimpleText } from '@eversports/react-components/primitives/Text'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { Localized } from '../../localization/react'
import { ConfirmWithOption } from '../../typings/Product'

import AssignedProductUsageInformation from './AssignedProductUsageInformation'

interface Props {
  assignedProduct: ConfirmWithOption
}

const AssignedProductName: React.FC<React.PropsWithChildren<Props>> = ({ assignedProduct }) => {
  const productValidity = assignedProduct.assignedProductValidity

  switch (assignedProduct.__typename) {
    case 'AssignedMembership':
      // TODO: tackle this once we have a validity for the memebership on the schema
      // const hasAutoExtension = Boolean(assignedProduct.product.runtime.renewal)
      // // TODO: make this have the actual extension date
      // const membershipInformation = hasAutoExtension ? (
      //   <Localized id="assigned-product-auto-extension-date" params={{ extensionDate: new Date('2020-03-31') }} />
      // ) : (
      //   // TODO make this have the actual valid until date
      //   <Localized
      //     id="assigned-product-valid-until"
      //     params={{ validUntil: assignedProduct.assignedProductValidity.usageLimitPeriod!.end }}
      //   />
      // )
      //
      const { usageLimitPeriod } = assignedProduct.assignedProductValidity

      const BookingsLeft = usageLimitPeriod ? (
        <Localized
          id="assigned-product-usage-limit-period"
          params={{
            end: new Date(usageLimitPeriod.end),
            remainingBookings: usageLimitPeriod.allowedBookings - usageLimitPeriod.usedBookings,
          }}
        />
      ) : null

      return (
        <SimpleFlex flexDirection="column">
          <SimpleText sx={{ fontWeight: 'bold' }} data-testid="assigned-membership-option">
            {assignedProduct.product.name}
          </SimpleText>
          <SimpleText sx={{ color: 'subtleText' }}>
            {productValidity.isValid ? BookingsLeft : productValidity.additionalInformation}
          </SimpleText>
        </SimpleFlex>
      )
    case 'AssignedCard':
      return (
        <SimpleFlex flexDirection="column">
          <SimpleText sx={{ fontWeight: 'bold' }} data-testid="assigned-card-option">
            {assignedProduct.product.name}
          </SimpleText>
          <SimpleText sx={{ color: 'subtleText' }}>
            {productValidity.isValid ? (
              <AssignedProductUsageInformation
                validUntil={assignedProduct.validUntil}
                usagesLeft={assignedProduct.usagesLeft}
                usages={assignedProduct.product.usages}
                usageLimitPeriod={productValidity.usageLimitPeriod}
              />
            ) : (
              productValidity.additionalInformation
            )}
          </SimpleText>
        </SimpleFlex>
      )
    default:
      return assertNever(assignedProduct)
  }
}

export default AssignedProductName
